export const phase0MeetingMinutes = [
  {
    label: 'View Phase 0 Meeting Minutes (Jan 26, 2026)',
    href: 'data/Hamro_Foolbari_Phase_0_Meeting_Minutes_2026-01-26.pdf',
  },
];

export const latestPhase0MeetingSummary = {
  title: 'Phase 0 Meeting Summary (Feb 8, 2026)',
  participants: ['Dilip', 'Ajay', 'Sujeet', 'Dinesh', 'Alok'],
  rows: [
    {
      area: 'Firm Establishment',
      actions:
        'Sujeet is registering the operating firm as a private entity; Ajay is registering the nonprofit in the US for governance and fundraising.',
    },
    {
      area: 'Initial Hiring (Phase 0 Support)',
      actions:
        'A mission-aligned individual was shortlisted, an offer was extended, and the role is focused on early information consolidation and coordination.',
    },
    {
      area: 'Location Research (Dolkha)',
      actions:
        'Potential school locations will be identified and assessed for accessibility and suitability.',
    },
    {
      area: 'Infrastructure Feasibility',
      actions:
        'Evaluate new construction versus purchasing/adapting an existing structure and compile high-level cost and timeline estimates.',
    },
    {
      area: 'Demographic & Education Data',
      actions:
        'Gather current population data, estimate children not currently enrolled, and assess realistic enrollment opportunities.',
    },
    {
      area: 'Financial Planning',
      actions:
        'Compile budgeting inputs and develop a projected two-year budget.',
    },
    {
      area: 'Phase 0 Closeout Goal',
      actions:
        'Legal setup is in progress, a preliminary hire is secured, and location/infrastructure/data inputs are being prepared for execution planning.',
    },
    {
      area: 'Phase 1 Readiness (Forward Look)',
      actions:
        'Transition from planning to execution, include marginalized groups without social friction, and begin facility setup and resource mobilization.',
    },
  ],
};

export const phase0AnalysisArtifacts = [
  {
    title: 'School Details by Local Level and District, 2076',
    description:
      'District-level and local-level school count reference used for location screening.',
    href: 'data/artifacts/School_Details_by_Local_Level_and_District_2076.pdf',
  },
  {
    title: 'Nepal Education Fact Sheets 2022 (MICS-EAGLE)',
    description:
      'Learning and equity indicators used to frame baseline education conditions.',
    href: 'data/artifacts/Nepal_Education_Fact_Sheets_2022_MICS-EAGLE.pdf',
  },
  {
    title: 'Shiksha Niyamawali, 2059',
    description:
      'Regulatory reference document used for compliance and policy context.',
    href: 'data/artifacts/Shiksha_Niyamawali_2059.pdf',
  },
  {
    title:
      'School Level Educational Statistics of Nepal Consolidated Report, 2011 (2068)',
    description:
      'Historical national school statistics used to support trend-level comparisons.',
    href:
      'data/artifacts/School_Level_Educational_Statistics_of_Nepal_Consolidated_Report_2011_2068.pdf',
  },
];
